import React, { Suspense } from 'react'
import Loader from '../../../../../components/loader'

// Loaded on demand: the tab is behind a flag, so its code stays out of the page until it is actually shown.
const NlToSqlFilter = React.lazy(() => import('./NlToSqlFilter'))

const LazyNlToSqlFilter: React.FC<React.ComponentProps<typeof NlToSqlFilter>> = (props) => (
    <Suspense
        fallback={
            <div className="flex justify-center items-center py-10">
                <Loader />
            </div>
        }
    >
        <NlToSqlFilter {...props} />
    </Suspense>
)

export default LazyNlToSqlFilter
